import React from 'react';

import cx from 'classnames';
import { isEmpty } from 'lodash';

import styles from './Button.module.scss';
import { ThemeProvider, Button as ButtonCore } from '@phonepe/enigma-ui';
import { TButtonProps } from './Button.types';

const Button = (props: TButtonProps) => {
	const {
		className = '',
		type = 'primary',
		size = 'medium',
		children,
		eventData,
		fullWidth = false,
		sendClickEvent,
		onClick,
		...restProps
	} = props;

	/** Garfield event ingestion */
	const onButtonClickHandler = (
		e: React.MouseEvent<HTMLElement, MouseEvent>,
	) => {
		if (!isEmpty(eventData)) {
			sendClickEvent?.(eventData);
		}

		onClick?.(e);
	};
	return (
		<ThemeProvider
			tokens={{
				// Remove these hard-coded colors after adding theme config for shared package
				colorPrimary: '#0073d8',
				colorLink: '#0073d8',
			}}
		>
			<ButtonCore
				{...restProps}
				size={size}
				type={type}
				block={fullWidth}
				className={cx(className, styles.button, {
					[styles.tertiaryBtn]: type === 'tertiary',
					[styles.textBtn]: type === 'text',
				})}
				onClick={onButtonClickHandler}
			>
				{children}
			</ButtonCore>
		</ThemeProvider>
	);
};

export default Button;
